import { createRouteRef } from '@backstage/core-plugin-api';
import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';
import { Icon } from '@iconify/react';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { assetsApiRef } from './api';

export const assetsPlugin = createFrontendPlugin({
  extensions: [TrpcApiBlueprint.make({
    name: 'assets-api',
    params: defineParams => defineParams({ apiRef: assetsApiRef, path: 'assets/trpc' }),
  }), PageBlueprint.make({
    params: {
      icon: <Icon icon="ri:gallery-line" />,
      loader: async () => {
        const { AssetsPage } = await import('./components/AssetsPage');
        return <AssetsPage />;
      },
      path: '/brand-space',
      routeRef: createRouteRef({ id: 'assets' }),
      title: 'Brand Space',
    },
  })],
  pluginId: 'assets',
});
